import _ from 'lodash'
import { EditSaleConditionsActionDrawer } from './EditSaleConditions/EditSaleConditionsActionDrawer'
import { RegisterTitlesForm } from './RegisterTitlesForm'

type Workflow = { id: string; text: string; drawer?: any }

export const defaultWorkflows: Record<string, Workflow> = _.keyBy(
    [
        {
            id: '1',
            text: 'Edit Sale Conditions',
            drawer: EditSaleConditionsActionDrawer,
        },
        {
            id: '2',
            text: 'Register Titles',
            drawer: RegisterTitlesForm,
        },
    ],
    'id',
)
